<template>
  <span>{{ formattedTime }}</span>
</template>

<script>
import secondsToElapseStringTime from '@/libs/secondsToElapseStringTime'

export default {
  props: {
    seconds: {}
  },

  computed: {
    formattedTime () {
      if (isNaN(this.seconds) && !this.seconds) return '00:00:00'
      return secondsToElapseStringTime(this.seconds)
    }
  }
}
</script>
